import { tv } from "@otomoro/helpers/mergeClasses";
import { VariantProps } from "tailwind-variants";

export const styles = tv({
  slots: {
    base: 'mx-2 md:mx-4 flex flex-col lg:flex-row justify-between lg:items-center mt-[1.5rem] lg:mt-2',
    list: 'flex flex-wrap space-x-1 mt-1 lg:mt-0',
  } 
})

export type CategoriesVariants = VariantProps<typeof styles>